import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { Forecast } from '../../types';
import apiService from '../../services/api';

interface ForecastsState {
  forecasts: Forecast[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ForecastsState = {
  forecasts: [],
  isLoading: false,
  error: null,
};

export const fetchForecasts = createAsyncThunk(
  'forecasts/fetchForecasts',
  async (params: any = {}, { rejectWithValue }) => {
    try {
      const response = await apiService.getForecasts(params);
      return response.result;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch forecasts');
    }
  }
);

const forecastsSlice = createSlice({
  name: 'forecasts',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchForecasts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchForecasts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.forecasts = action.payload as Forecast[];
      })
      .addCase(fetchForecasts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = forecastsSlice.actions;
export default forecastsSlice.reducer;
